import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // get account txn list
    getAccountTxnList: (context, { from, to, accountId, customerId, vendorId }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/account-txn-list?from=" + from + "&to=" + to
      if (accountId) {
        path = path + "&accountId=" + accountId
      }
      if (customerId) {
        path = path + "&customerId=" + customerId
      } else if (vendorId) {
        path = path + "&vendorId=" + vendorId
      }
      return apiUtils.get(path)
    },
    // get account txns
    getAccountTxns: (context, { from, to, accountId }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/account-txns?accountId=" + accountId + "&from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    //get account balances
    getAccountBalances: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/account-balances?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    // get customer aged receivables
    getCustomerAgedReceivables: (context, { date }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/customer-aged-receivables?date=" + date
      return apiUtils.get(path)
    },
    // get vendor aged payables
    getVendorAgedPayables: (context, { date }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/vendor-aged-payables?date=" + date
      return apiUtils.get(path)
    },
    //get customer income
    getCustomerIncome: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/customer-income?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    //get vendor purchase
    getVendorPurchase: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/vendor-purchase?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    //get sales tax
    getSalesTax: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/sales-tax?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    //get trial balances
    getTrailBalance: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/trial-balances?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    //get income statement
    getIncomeStatement: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/income-statement?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    // get balance sheet
    getBalanceSheet: (context, { to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/balance-sheet?to=" + to
      return apiUtils.get(path)
    },
    // get cash flow
    getCashFlow: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/reports/cash-flow?from=" + from + "&to=" + to
      return apiUtils.get(path)
    }
  }
}
